import { render, staticRenderFns } from "./AppPillTab.vue?vue&type=template&id=65a0bcf4"
import script from "./AppPillTab.vue?vue&type=script&lang=js"
export * from "./AppPillTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports